import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-solar-script-dialog',
  templateUrl: './solar-script-dialog.component.html',
  styleUrls: ['./solar-script-dialog.component.css'],
  standalone: true,
  imports: [CommonModule]
})
export class SolarScriptDialogComponent implements OnInit {
  @Input() deviceInfoData: any;
  constructor( private titleService: Title) {  
  }

  ngOnInit(): void {
  }

}
